const compare = (id, nowParams, oldParams, tracker) => {
  const obj = {};
  Object.keys(nowParams)?.forEach((key: any) => {
    if (key === 'noticeLabels') {
      if (nowParams[key].length !== oldParams[key]?.length) {
        obj[key] = nowParams[key];
      } else {
        for (let i = 0; i < nowParams[key].length; i++) {
          const lb = nowParams[key][i];
          const have = oldParams[key].find((old: any) => old === lb);
          if (!have) {
            obj[key] = nowParams[key];
            break;
          }
        }
      }
    } else if (key === 'meetingFolderAddForms') {
      const files = nowParams[key] || [];
      if (files.length !== oldParams?.meetingFolderViews?.length) {
        obj[key] = nowParams[key];
      } else {
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          const have = oldParams?.meetingFolderViews?.find((old: any) => old.fileKey === file.fileKey);
          if (!have) {
            obj[key] = nowParams[key];
            break;
          }
        }
      }
    } else if (key === 'members') {
      const ids = nowParams[key]?.staffIdList || [];
      for (let i = 0; i < ids.length; i++) {
        const userId = ids[i];
        const have = oldParams[key].find((old: any) => old.user?.staffId === userId);
        if (!have) {
          obj[key] = nowParams[key];
          break;
        }
      }
    } else if (key === 'roomBookingForms') {
      const rooms = nowParams[key] || [];
      if (rooms.length !== oldParams?.roomOrderList?.length) {
        obj[key] = nowParams[key];
      } else {
        for (let i = 0; i < rooms.length; i++) {
          const room = rooms[i];
          const have = oldParams?.roomOrderList?.find((old: any) => old.roomId === room.roomId);
          if (!have) {
            obj[key] = nowParams[key];
            break;
          }
        }
      }
    } else if (key === 'recurrence') {
      obj[key] = undefined;
    } else {
      if (nowParams[key] !== oldParams[key]) {
        obj[key] = nowParams[key];
      }
    }
  });
  tracker?.reporteMeetingSetting(id, obj);
};

export default compare;
